import { Component } from '@angular/core';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-transaction-details-page',
  templateUrl: './transaction-details-page.component.html',
  standalone: false,
})
export class TransactionDetailsPageComponent extends BasePage {
  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }
}
